import React, { Suspense, lazy } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import history from "@sijal/common/src/config/history";
import Loading from "@sijal/common/src/components/Loading";

const Agent = lazy(() => import("../Agent/layouts/Agent"));
const Website = lazy(() => import("../Website/Website"));
const Login = lazy(() => import("../components/Auth/Login"));
const Logout = lazy(() => import("@sijal/common/src/config/Logout"));

const MainRoute = () => {
  return (
    <Router history={history}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path="/logout" name="Logout" component={Logout} />
          <Route path="/login" component={Login} />
          <Route path="/a" component={Agent} name="Agent" />
          <Route path="/student" component={Website} name="Website" />
          <Redirect from="/" to="/login" />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default MainRoute;
